/* Notify me on sold-out sizes (DESIGN.md §9, H7).
   A size change morphs only the variant picker, so this block would keep the
   first variant's state. Like product-inventory.js, it listens for the product
   select on its section and copies its own contents from the re-rendered
   section: the form appears on a sold-out size, carries that size in its
   hidden fields, and empties on an in-stock one. */

import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class BettinoNotifyMe extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const next = detail.html.querySelector('bettino-notify-me');
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[bettino-notify-me] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('bettino-notify-me')) {
  customElements.define('bettino-notify-me', BettinoNotifyMe);
}
